import { render } from "./ManageUniqueCodes.vue?vue&type=template&id=466a55a6"
import script from "./ManageUniqueCodes.vue?vue&type=script&lang=js"
export * from "./ManageUniqueCodes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__